import React, { useEffect, useState } from "react";

type MobilePane = "generation" | "preview";

const DETAILS_BODY_SELECTOR = ".product-detail > .details-body";

export const ProductDetailMobileColumnTabs: React.FC = () => {
  const [pane, setPane] = useState<MobilePane>("generation");

  useEffect(() => {
    const body = document.querySelector(DETAILS_BODY_SELECTOR);
    if (body) {
      body.setAttribute("data-mobile-pane", pane);
    }
  }, [pane]);

  return (
    <div
      className="txu-tab tw-px-5 tw-pt-2"
      data-testid="product-detail-mobile-column-tabs"
    >
      <nav>
        <button
          type="button"
          className={`item tw-bg-transparent tw-border-0 tw-appearance-none${
            pane === "generation" ? " active" : ""
          }`}
          data-testid="product-detail-mobile-tab-generation"
          onClick={(): void => setPane("generation")}
        >
          Generation
        </button>
        <button
          type="button"
          className={`item tw-bg-transparent tw-border-0 tw-appearance-none${
            pane === "preview" ? " active" : ""
          }`}
          data-testid="product-detail-mobile-tab-preview"
          onClick={(): void => setPane("preview")}
        >
          Preview
        </button>
      </nav>
    </div>
  );
};
